import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { ContentPageTheme, ContentPageThemeDefault, Media, Page } from ".";

const CONTENT_PAGE_THEME_SERVICE = `${Constants.API_URL}/bedrock/content_page_themes`;

export type GetPageThemesParams = {
  search?: string;
  page?: number;
  perPage?: number;
};

export interface ContentPageThemeRequest {
  name?: string;
  backgroundColor?: string;
  textColor?: string;
  primaryCtaColor?: string;
  primaryCtaTextColor?: string;
  headerMedia?: Media[];
  footerMedia?: Media[];
  showEhLenderLogo?: boolean;
  showEhOpportunityLogo?: boolean;
  disclaimer?: string;
  makeDefault?: boolean;
}

export class ContentPageThemeServices {
  @scCatchServiceException()
  static async getPageThemes(params: GetPageThemesParams = {}): Promise<Page<ContentPageTheme>> {
    const { data } = await axios.get<Page<ContentPageTheme>>(CONTENT_PAGE_THEME_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async getPageTheme(themeId: number): Promise<ContentPageTheme> {
    const { data } = await axios.get<ContentPageTheme>(`${CONTENT_PAGE_THEME_SERVICE}/${themeId}`);
    return data;
  }

  @scCatchServiceException()
  static async createPageTheme(request: ContentPageThemeRequest): Promise<ContentPageTheme> {
    const { data } = await axios.post<ContentPageTheme>(CONTENT_PAGE_THEME_SERVICE, request);
    return data;
  }

  @scCatchServiceException()
  static async updatePageTheme(themeId: number, request: ContentPageThemeRequest): Promise<ContentPageTheme> {
    const { data } = await axios.patch<ContentPageTheme>(`${CONTENT_PAGE_THEME_SERVICE}/${themeId}`, request);
    return data;
  }

  @scCatchServiceException()
  static async deletePageTheme(themeId: number): Promise<void> {
    const { data } = await axios.delete<void>(`${CONTENT_PAGE_THEME_SERVICE}/${themeId}`);
    return data;
  }

  @scCatchServiceException()
  static async getPageThemeDefaults(page = 1, perPage = 25): Promise<Page<ContentPageThemeDefault>> {
    const { data } = await axios.get<Page<ContentPageThemeDefault>>(`${CONTENT_PAGE_THEME_SERVICE}/defaults`, {
      params: { page, perPage },
    });
    return data;
  }

  @scCatchServiceException()
  static async updatePageThemeDefaults(defaults: ContentPageThemeDefault[]): Promise<ContentPageThemeDefault[]> {
    const { data } = await axios.post<ContentPageThemeDefault[]>(`${CONTENT_PAGE_THEME_SERVICE}/update_defaults`, {
      defaults,
    });
    return data;
  }
}
